// CONFIG
export const COLORS = ["#C6654A", "#D59E5D", "#F8E877", "#97BD76", "#9999F9"];

export const AVG_PILL_ABOVE_BAR_TOP = "-10px";

const BAR_TOP_PCT = 11;
const BAR_SPAN_PCT = 89;
const MIN_RED_BAND_PCT = 2;

export function bandLayout(
    veryLow: number,
    low: number,
    medium: number,
    high: number
): { tops: number[]; toTop: (v: number) => number } {
    const t = [0, veryLow, low, medium, high];
    const h = [0, 1, 2, 3].map((i) => ((t[i + 1] - t[i]) / high) * BAR_SPAN_PCT);

    const deficit = MIN_RED_BAND_PCT - h[0];
    if (deficit > 0) {
        const donor = [1, 2, 3].reduce((best, i) => (h[i] > h[best] ? i : best), 1);
        const take = Math.min(deficit, h[donor] * 0.5);
        h[0] += take;
        h[donor] -= take;
    }

    const tops = [BAR_TOP_PCT + BAR_SPAN_PCT];
    for (let i = 0; i < 4; i++) {
        tops.push(tops[i] - h[i]);
    }

    const toTop = (v: number): number => {
        if (v >= high) return tops[4];
        if (v <= 0) return tops[0];
        for (let i = 0; i < 4; i++) {
            if (v >= t[i] && v <= t[i + 1] && t[i + 1] > t[i]) {
                return tops[i] - ((v - t[i]) / (t[i + 1] - t[i])) * h[i];
            }
        }
        return tops[0];
    };

    return { tops, toTop };
}

export function fmtBar(v: number): string {
    if (v >= 1000) return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
    if (v > 100) return Math.round(v).toString();
    return parseFloat(v.toFixed(2)).toString();
}

export function fmtPercentOfField(v: number): string {
    return `${parseFloat(v.toFixed(1))}% of Field`;
}

export function fmt(v: number): string {
    if (v >= 1000) return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
    if (v >= 10) return parseFloat(v.toFixed(1)).toString();
    return parseFloat(v.toFixed(2)).toString();
}
